<template>
  <div class="text-base lg:text-lg">
    <slot />
  </div>
</template>
